import {
  BatchRequestDocument,
  RequestDocument,
  Variables,
  GraphQLClient,
} from 'graphql-request'

const graphqlUrl = process.env.GRAPHQL_URL

export const statamicConfig =
  process.env.NEXT_PUBLIC_STATAMIC_SITE_HANDLE === 'blink'
    ? {
        collections: ['blink', 'blink_magazine', 'blink_partners'],
        settingsHandle: 'blink_settings',
        catcherHandle: 'blink_catcher',
        navHandle: 'blink_navigation',
        secondaryNavHandle: 'blink_secondary',
        footerNavHandle: 'blink_footer',
        magazineCollection: ['blink_magazine'],
      }
    : process.env.NEXT_PUBLIC_STATAMIC_SITE_HANDLE === 'nohe'
      ? {
          collections: ['nohe', 'nohe_magazine'],
          settingsHandle: 'nohe_settings',
          catcherHandle: 'nohe_catcher',
          navHandle: 'nohe_navigation',
          secondaryNavHandle: 'nohe_secondary',
          footerNavHandle: 'nohe_footer',
          magazineCollection: ['nohe_magazine'],
        }
      : {
          collections: ['flch', 'flch_dynamic'],
          settingsHandle: 'flch_settings',
          navHandle: 'flch_navigation',
          footerNavHandle: 'flch_footer',
        }

export async function batchRequests<
  T extends Array<any> = any[],
  V extends Variables = Variables,
>(documents: BatchRequestDocument<V>[], previewToken?: string): Promise<T> {
  const response: any = await Promise.all(
    documents.map((query) => {
      return request(query.document, query.variables, previewToken)
    })
  )

  return response as Promise<T>
}

export async function request<T = any, V extends Variables = Variables>(
  document: RequestDocument,
  variables?: V,
  previewToken?: string
): Promise<T> {
  const url = previewToken ? `${graphqlUrl}?token=${previewToken}` : graphqlUrl

  const client = new GraphQLClient(url, { fetch: fetch })

  return client.request(document, variables, {
    'x-secret': process.env.CMS_SECRET || '',
  })
}
